// extracted by mini-css-extract-plugin
export var layout = "Surgery-module--layout--35a6b";
export var text = "Surgery-module--text--458c5";